 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK_4345 from '@/components/eBook_4345'
 import EBOOK_43451 from '@/components/eBook_4345-1'
 import EBOOK_43452 from '@/components/eBook_4345-2'
 import EBOOK_43453 from '@/components/eBook_4345-3'
 import EBOOK_43454 from '@/components/eBook_4345-4'
 import EBOOK_43455 from '@/components/eBook_4345-5'
 import EBOOK_43456 from '@/components/eBook_4345-6'
 import EBOOK_43457 from '@/components/eBook_4345-7'
 import EBOOK_43458 from '@/components/eBook_4345-8'
 import EBOOK_43459 from '@/components/eBook_4345-9'
 import EBOOK_434510 from '@/components/eBook_4345-10'
 import EBOOK_434511 from '@/components/eBook_4345-11'
 import EBOOK_434512 from '@/components/eBook_4345-12'
 import EBOOK_434513 from '@/components/eBook_4345-13'
 import EBOOK_434514 from '@/components/eBook_4345-14'
 import EBOOK_434515 from '@/components/eBook_4345-15'
 import EBOOK_434516 from '@/components/eBook_4345-16'
 import EBOOK_434517 from '@/components/eBook_4345-17'
 import EBOOK_434518 from '@/components/eBook_4345-18'
 import EBOOK_434519 from '@/components/eBook_4345-19'
 import EBOOK_434520 from '@/components/eBook_4345-20'
 import EBOOK_434521 from '@/components/eBook_4345-21'
 import EBOOK_434522 from '@/components/eBook_4345-22'
 import EBOOK_434523 from '@/components/eBook_4345-23'
 import EBOOK_434524 from '@/components/eBook_4345-24'
 import EBOOK_434525 from '@/components/eBook_4345-25'
 import EBOOK_434526 from '@/components/eBook_4345-26'
 import EBOOK_434527 from '@/components/eBook_4345-27'
 import EBOOK_434528 from '@/components/eBook_4345-28'
 import EBOOK_434529 from '@/components/eBook_4345-29'
 import EBOOK_434530 from '@/components/eBook_4345-30'
 import EBOOK_434531 from '@/components/eBook_4345-31'
 import EBOOK_434532 from '@/components/eBook_4345-32'
 import EBOOK_434533 from '@/components/eBook_4345-33'
 import EBOOK_434534 from '@/components/eBook_4345-34'
 import EBOOK_434535 from '@/components/eBook_4345-35'
 import EBOOK_434536 from '@/components/eBook_4345-36'
 import EBOOK_434537 from '@/components/eBook_4345-37'
 import EBOOK_434538 from '@/components/eBook_4345-38'
 import EBOOK_434539 from '@/components/eBook_4345-39'
 import EBOOK_434540 from '@/components/eBook_4345-40'
 import EBOOK_434541 from '@/components/eBook_4345-41'
 import EBOOK_434542 from '@/components/eBook_4345-42'
 import AAAATURN from '@/components/AA/AA-turn'
 import AAAACOVER from '@/components/AA/AA-cover'
 import AAAA from '@/components/AA/AA'
 import EBOOK_434543 from '@/components/eBook_4345-43'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/eBook_4345",
 			"name" : "eBook_4345",
 			"component" : EBOOK_4345
 		},
 		{
 			"path" : "/eBook_4345-1",
 			"name" : "eBook_4345-1",
 			"component" : EBOOK_43451
 		},
 		{
 			"path" : "/eBook_4345-2",
 			"name" : "eBook_4345-2",
 			"component" : EBOOK_43452
 		},
 		{
 			"path" : "/eBook_4345-3",
 			"name" : "eBook_4345-3",
 			"component" : EBOOK_43453
 		},
 		{
 			"path" : "/eBook_4345-4",
 			"name" : "eBook_4345-4",
 			"component" : EBOOK_43454
 		},
 		{
 			"path" : "/eBook_4345-5",
 			"name" : "eBook_4345-5",
 			"component" : EBOOK_43455
 		},
 		{
 			"path" : "/eBook_4345-6",
 			"name" : "eBook_4345-6",
 			"component" : EBOOK_43456
 		},
 		{
 			"path" : "/eBook_4345-7",
 			"name" : "eBook_4345-7",
 			"component" : EBOOK_43457
 		},
 		{
 			"path" : "/eBook_4345-8",
 			"name" : "eBook_4345-8",
 			"component" : EBOOK_43458
 		},
 		{
 			"path" : "/eBook_4345-9",
 			"name" : "eBook_4345-9",
 			"component" : EBOOK_43459
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js